<template>
  <v-container fluid class="py-8">
    <v-layout wrap justify-center>
      <v-flex xs12 md10 lg8>
        <v-card class="elevation-2 rounded-lg pb-6">
          <v-card-title class="headline font-weight-medium pa-6 pb-2" style="color: #1f2d24;">
            Upload Employee Payslips
          </v-card-title>
          
          <v-divider class="mb-8"></v-divider>
          
          <v-card-text class="px-8 text-center">
            
            <v-layout wrap justify-center>
              <v-flex xs12 sm10 md8 align-self-center pa-2>
                <!-- Small Box matching add target -->
                <v-card outlined class="bulk-upload-card pa-3 mx-auto" style="max-width: 500px; background-color: #fafdfb;">
                  <v-layout wrap align-center>
                    <v-flex xs12 sm8 align-self-center text-left pa-1>
                      <v-layout align-start style="flex-wrap: nowrap;">
                        <v-flex shrink align-self-start pr-3 pt-1>
                          <v-icon :color="uploadedFileName ? '#005f32' : '#90a4ae'" size="32px">
                            mdi-file-excel
                          </v-icon>
                        </v-flex>
                        <v-flex align-self-start class="bulk-file-name" style="flex: 1; min-width: 0;">
                          <div v-if="uploadedFileName">
                            <div class="bulk-file-title">Selected File</div>
                            <div class="bulk-file-name__text bulk-file-name__text--selected" :title="uploadedFileName">
                              {{ uploadedFileName }}
                            </div>
                            <div class="bulk-file-badge mt-1">
                              Ready for Upload
                            </div>
                          </div>
                          <div v-else class="mt-1">
                            <span class="bulk-file-name__text" style="color: #78909c;">No file selected</span>
                            <span class="bulk-helper-text mt-1">Supported formats: .xlsx, .xls</span>
                          </div>
                        </v-flex>
                        <v-flex v-if="uploadedFileName" shrink align-self-start pl-2 pt-1>
                          <v-btn icon small @click="clearSelectedFile" :disabled="loading" title="Remove file">
                            <v-icon color="#e53935" size="22px">mdi-close-circle</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm4 align-self-center text-right pa-1>
                      <v-btn 
                        color="#005f32" 
                        dark 
                        depressed
                        class="rounded-pill px-4 text-capitalize font-weight-bold" 
                        @click="$refs.payslipUpload.click()" 
                        :disabled="loading"
                      >
                        <v-icon left size="18">mdi-folder-search-outline</v-icon>
                        Browse
                      </v-btn>
                      <input
                        v-show="false"
                        ref="payslipUpload"
                        type="file"
                        accept=".xlsx, .xls"
                        @change="handleFileUpload"
                      />
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>

            <!-- Upload Button -->
            <v-expand-transition>
              <v-layout wrap justify-center py-6 v-if="uploadedFileName && !loading">
                <v-flex xs12 sm8 md6 align-self-center px-4>
                  <v-btn
                    color="#005f32"
                    dark
                    large
                    elevation="2"
                    class="rounded-pill px-8 font-weight-bold text-capitalize"
                    block
                    :loading="loading"
                    @click="uploadFile"
                  >
                    <v-icon left>mdi-cloud-upload</v-icon>
                    Upload and Process Payslips
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-expand-transition>
            
            <!-- Result Message -->
            <v-expand-transition>
              <div v-if="message" class="mt-6 mx-auto" style="max-width: 600px;">
                <v-alert
                  :type="isError ? 'error' : 'success'"
                  border="left"
                  elevation="1"
                  colored-border
                  class="text-left font-weight-medium mb-0 rounded-lg"
                >
                  {{ message }}
                </v-alert>
              </div>
            </v-expand-transition>

          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'UploadPayslip',
  data() {
    return {
      file: null,
      uploadedFileName: "",
      loading: false,
      message: '',
      isError: false,
    };
  },
  methods: {
    clearSelectedFile() {
      this.file = null;
      this.uploadedFileName = "";
      if (this.$refs.payslipUpload) {
        this.$refs.payslipUpload.value = "";
      }
    },
    handleFileUpload(event) {
      const file = event.target.files ? event.target.files[0] : null;
      if (!file) return;
      this.file = file;
      this.uploadedFileName = file.name;
    },
    async uploadFile() {
      if (!this.file) return;

      this.loading = true;
      this.message = '';
      this.isError = false;

      const formData = new FormData();
      formData.append('payslips', this.file);

      try {
        const response = await axios.post(`/admin/payslips/upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-auth-token': localStorage.getItem("token")
          }
        });
        
        if (response.data.status) {
          this.message = response.data.msg;
          this.isError = false;
          this.clearSelectedFile();
        } else {
          this.message = response.data.msg || 'Upload failed';
          this.isError = true;
        }
      } catch (error) {
        this.message = error.response?.data?.msg || 'An error occurred during upload.';
        this.isError = true;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.bulk-upload-card {
  border-color: #d8e2dc !important;
  border-radius: 6px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.bulk-upload-card:hover {
  border-color: #005f32 !important;
  box-shadow: 0 2px 10px rgba(0, 95, 50, 0.08);
}

.bulk-file-name {
  min-width: 0;
}

.bulk-file-name__text {
  color: #333;
  display: block;
  font-family: kumbhRegular;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bulk-file-name__text--selected {
  color: #1f2d24;
  font-family: kumbhMedium;
}

.bulk-file-title {
  font-size: 11px;
  color: #546e7a;
  font-family: kumbhMedium;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1.2;
  margin-bottom: 2px;
}

.bulk-file-badge {
  display: inline-block;
  color: #005f32;
  font-size: 11px;
  font-weight: bold;
  background-color: #e8f5e9;
  padding: 2px 8px;
  border-radius: 12px;
  margin-top: 4px;
  margin-bottom: 2px;
  font-family: kumbhMedium;
}

.bulk-helper-text {
  color: #78909c;
  display: block;
  font-family: kumbhRegular;
  font-size: 11px;
  margin-top: 2px;
}
</style>
